// import moment from 'moment'

export default {
  getServiceArea (VueApp, callback) {
    VueApp.$sdk.get('/geofences', {
      // order: VueApp.$store.state.brands.webform.order,
      // orderAsc: VueApp.$store.state.brands.webform.orderAsc
      order: VueApp.$store.state.brands.webform.order,
      orderAsc: VueApp.$store.state.brands.webform.orderAsc
    }, res => {
      if (!res.error && res.list.length) {
        let serviceArea = []
        let filtered = res.list.filter(x => x.type === 'servicearea')
        filtered.forEach(function (data) {
          serviceArea.push({
            id: data.id,
            name: data.name
          })
        })
        VueApp.$store.commit('brands/setServiceAreaList', serviceArea)
      }
      callback(res)
    })
  },
  getWebforms (VueApp, callback) {
    VueApp.$sdk.get('/webform', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error && res.list.length) {
        let webforms = []
        res.list.forEach(function (data) {
          webforms.push({
            id: data.id,
            name: data.name
          })
        })
        VueApp.$store.commit('brands/setWebformList', webforms)
      }
      callback(res)
    })
  },
  getWebformData (VueApp, id, callback) {
    VueApp.$sdk.get('/webform/' + id + '/geofences', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('brands/updatedWebform', {
          id: id,
          geofencesIDs: res.geofenceIds
        })
      }
      callback(res)
    })
  },
  updateWebform (VueApp, data, callback) {
    VueApp.$sdk.post('/webform/' + data.id + '/geofences', {
      token: VueApp.$store.state.session.sessionToken,
      geofenceIds: data.geoIDs
    }, res => {
      callback(res)
    })
  },
  addWebform (VueApp, data, callback) {
    let self = this
    VueApp.$sdk.post('/webform/', {
      token: VueApp.$store.state.session.sessionToken,
      name: data.name
    }, res => {
      if (!res.error) {
        self.updateWebform(VueApp, {id: res.id, geoIDs: data.geoIDs}, function (res2) {
          callback(res2)
        })
      } else {
        callback(res)
      }
    })
  },
  deleteWebform (VueApp, id, callback) {
    VueApp.$sdk.delete('/webform/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/brands/webforms.js